import React from 'react';
import { Flex, Text } from '@tonic-ui/react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from '../../components/external-link';

type Resource = {
  links: { text: string; href: string }[];
  title: string;
};

const ResourcesLinks = (): JSX.Element => {
  const { t } = useTranslation('', { keyPrefix: 'support.supportPage' });
  const resourceLinks: Resource[] = t('resources', { returnObjects: true });

  return (
    <Flex direction="column" data-id="resources" padding="5x">
      <Text size="md" fontWeight="normal" mb="5x">
        {t('resourcesTitle')}
      </Text>
      {resourceLinks.map(({ links, title }: Resource, index: number) => (
        <Flex direction="column" key={`support-resource-${index}`} mb="5x">
          <Text fontWeight="semibold">{title}</Text>
          {links.map((link, idx) => (
            <ExternalLink
              href={link.href}
              showIcon={false}
              key={`support-link-${idx}`}
              textDecoration="none"
            >
              {link.text}
            </ExternalLink>
          ))}
        </Flex>
      ))}
    </Flex>
  );
};

ResourcesLinks.displayName = 'ResourcesLinks ';
export default ResourcesLinks;
